export const format = (v: number = 0, minDigits: number = 0, maxDigits: number = 2) =>
	v.toLocaleString(undefined, {
		minimumFractionDigits: minDigits,
		maximumFractionDigits: maxDigits,
	})
